export enum FeeCalculatorSectionId {
  FamilyMembers = "FamilyMembers",
  PortfolioLevel = "PortfolioLevel",
  InvestmentOptions = "InvestmentOptions",
  PortfolioSetup = "PortfolioSetup",
  HoldingSizes = "HoldingSizes",
  CFSEdgeOptional = "CFSEdgeOptional",
  NorthOptional = "NorthOptional",
  HoldingNumber = "HoldingNumber",
  TransactionOutside = "TransactionOutside",
  TransactionWithin = "TransactionWithin",
  RetailInsurance = "RetailInsurance",
}
